import MessageCircle from '../../assets/img/message-circle.png'

const PLANS = {
  label: 'Subscription Plans',
  pathname: '/',
  exact: true
}

const REFERRAL = {
  label: 'Give $30 Get $30',
  pathname: '/',
  exact: true
}

const HELP = {
  label: 'Help',
  pathname: 'https://cookunitysupport.zendesk.com',
  component: 'a'
}

const NEED_HELP = {
  label: 'Need Help?',
  pathname: 'https://cookunitysupport.zendesk.com',
  component: 'a',
  icon: MessageCircle
}

export const mainLinks = [PLANS, REFERRAL, HELP]

export const checkoutLinks = [NEED_HELP]



// WEBPACK FOOTER //
// ./src/modules/Header/constants.js